import React from 'react';

function Construc () {
    return (
        <div className="espacio">
            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_559/v1611108964/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_8.14.44_PM.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
        </div>
    )
}

export default Construc